"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.inAppMessageFromBridgeOutputs = exports.isBridgeWorkflow = void 0;
const types_1 = require("../types");
const isBridgeWorkflow = (workflowType) => {
    return workflowType === types_1.WorkflowTypeEnum.BRIDGE || workflowType === types_1.WorkflowTypeEnum.ECHO;
};
exports.isBridgeWorkflow = isBridgeWorkflow;
/**
 * This function maps the V2 InAppOutput to the V1 MessageEntity.
 */
const inAppMessageFromBridgeOutputs = (outputs) => {
    const cta = {
        type: types_1.ChannelCTATypeEnum.REDIRECT,
        data: {
            url: outputs?.redirect?.url,
            target: outputs?.redirect?.target,
        },
        action: {
            result: {},
            buttons: [
                ...(outputs?.primaryAction
                    ? [
                        {
                            type: types_1.ButtonTypeEnum.PRIMARY,
                            content: outputs.primaryAction.label,
                            url: outputs.primaryAction.redirect?.url,
                            target: outputs?.primaryAction.redirect?.target,
                        },
                    ]
                    : []),
                ...(outputs?.secondaryAction
                    ? [
                        {
                            type: types_1.ButtonTypeEnum.SECONDARY,
                            content: outputs.secondaryAction.label,
                            url: outputs.secondaryAction.redirect?.url,
                            target: outputs?.secondaryAction.redirect?.target,
                        },
                    ]
                    : []),
            ],
        },
    };
    return {
        subject: outputs?.subject,
        content: outputs?.body || '',
        cta,
        avatar: outputs?.avatar,
        data: outputs?.data,
    };
};
exports.inAppMessageFromBridgeOutputs = inAppMessageFromBridgeOutputs;
//# sourceMappingURL=bridge.utils.js.map